import { put } from 'redux-saga/effects';
import AuthActions from '../redux/AuthRedux';
import CustomersActions from '../redux/CustomersRedux';
import i18n from '../i18n';
import { setLanguage } from '../lib/Utils';
import decode from 'jwt-decode';
import Global from '../lib/Global';

export function* login(api, { username, password }) {
  try {
    const loginResponse = yield api.login(username, password);
    console.log('loginResponse:', loginResponse)
    if (loginResponse.status === 201) {
      // we have tfa, two factor authentication
      const token = loginResponse.data?.token
      yield put(AuthActions.loginRequestSuccessRedirectToTfa(token))
      // yield put(AuthActions.loginRequestSuccess(null, null, null, null, null, null, null, true, false, null, null, token))
    } else if (loginResponse.status === 200) {
      const decodedToken = decode(loginResponse.data.token);
      console.log('decodedToken:', decodedToken);
      let distributorId = '',
        customerId = '',
        role = null,
        languageId = 1,
        customerProfile = null,
        distributorIdSub = null,
        customersWithSub = null,
        authCustomerIdSub = null;

      if (decodedToken) {
        ({ distributorId, customerId, role, languageId, customerProfile } = decodedToken);
        distributorIdSub = decode(distributorId).sub;
        authCustomerIdSub = decode(customerId).sub;
      }
      Global.api = {
        ...Global.api,
        accessToken: loginResponse.data.token,
      };

      const customersResponse = yield api.getCustomers();
      console.log('customersResponse:', customersResponse);
      if (customersResponse.ok) {
        const { data } = customersResponse;
        customersWithSub = data.map((customer) => {
          const decodedToken = customer && customer.customerId ? decode(customer.customerId) : null;
          const customerIdSub = decodedToken ? decodedToken.sub : null;
          return { ...customer, customerIdSub };
        });
        yield put(CustomersActions.customersRequestSuccess(customersWithSub));
      }
      const defaultCustomer = customersWithSub.find((customer) => customer.customerIdSub === authCustomerIdSub);


      console.log('loginResponse.data.token:', loginResponse.data.token);
      setLanguage(languageId);
      yield put(
        AuthActions.loginRequestSuccess(
          loginResponse.data.token,
          defaultCustomer?.distributorId,
          defaultCustomer?.customerId,
          defaultCustomer?.customerIdSub,
          distributorIdSub,
          customerProfile,
          role,
          false,
          true,
          distributorIdSub,
          authCustomerIdSub
        )
      );
    } else {
      const error = i18n.t('unexpectedError');
      yield put(AuthActions.loginRequestFailure(error));
    }
  } catch (error) {
    yield put(AuthActions.loginRequestFailure(error));
  }
}

export function* twoFactorAuthenticate(api, { params }) {
  try {
    const loginResponse = yield api.twoFactorAuthenticate(params);
    if (loginResponse.ok) {
      const decodedToken = decode(loginResponse.data.token);
      let distributorId = '',
        customerId = '',
        role = null,
        languageId = 1,
        customerProfile = null,
        distributorIdSub = null,
        customersWithSub = null,
        authCustomerIdSub = null;

      if (decodedToken) {
        ({ distributorId, customerId, role, languageId, customerProfile } = decodedToken);
        distributorIdSub = decode(distributorId).sub;
        authCustomerIdSub = decode(customerId).sub;
      }
      Global.api = {
        ...Global.api,
        accessToken: loginResponse.data.token,
      };

      const customersResponse = yield api.getCustomers();
      if (customersResponse.ok) {
        const { data } = customersResponse;
        customersWithSub = data.map((customer) => {
          const decodedToken = customer && customer.customerId ? decode(customer.customerId) : null;
          const customerIdSub = decodedToken ? decodedToken.sub : null;
          return { ...customer, customerIdSub };
        });
        yield put(CustomersActions.customersRequestSuccess(customersWithSub));
      }
      const defaultCustomer = customersWithSub.find((customer) => customer.customerIdSub === authCustomerIdSub);

      setLanguage(languageId);
      yield put(
        AuthActions.loginRequestSuccess(
          loginResponse.data.token,
          defaultCustomer?.distributorId,
          defaultCustomer?.customerId,
          defaultCustomer?.customerIdSub,
          distributorIdSub,
          customerProfile,
          role,
          false,
          true,
          distributorIdSub,
          authCustomerIdSub
        )
      );
    } else {
      const error = i18n.t('unexpectedError');
      yield put(AuthActions.twoFactorAuthenticateRequestFailure(error));
    }
  } catch (error) {
    yield put(AuthActions.twoFactorAuthenticateRequestFailure(error));
  }
}

export function* sendResetPasswordEmail(api, { username, url }) {
  try {
    const sendResetPasswordEmailResponse = yield api.sendResetPasswordEmail(username, url);
    const successMessage = i18n.t('successMessage.sendResetPasswordEmail');
    if (sendResetPasswordEmailResponse.ok) {
      yield put(AuthActions.sendResetPasswordEmailRequestSuccess(successMessage));
    } else {
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof sendResetPasswordEmailResponse.problem !== 'undefined'
          ? sendResetPasswordEmailResponse.problem
          : typeof sendResetPasswordEmailResponse.data.error !== 'undefined'
            ? sendResetPasswordEmailResponse.data.error
            : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(AuthActions.sendResetPasswordEmailRequestFailure(error));
    }
  } catch (error) {
    yield put(AuthActions.sendResetPasswordEmailRequestFailure(error));
  }
}

export function* resetPassword(api, { params }) {
  try {
    const resetPasswordResponse = yield api.resetPassword(params);
    const successMessage = i18n.t('successMessage.resetPassword');
    if (resetPasswordResponse.ok) {
      yield put(AuthActions.resetPasswordRequestSuccess(successMessage));
    } else {
      let error = i18n.t('unexpectedError');
      let errorBody =
        typeof resetPasswordResponse.problem !== 'undefined'
          ? resetPasswordResponse.problem
          : typeof resetPasswordResponse.data.error !== 'undefined'
            ? resetPasswordResponse.data.error
            : null;
      if (errorBody) {
        error += `: ${errorBody}`;
      }
      yield put(AuthActions.resetPasswordRequestFailure(error));
    }
  } catch (error) {
    console.log('error in auth sagas', error);
  }
}
